/**
 * Geometry
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides all helper functions related to general geometry calculations.
 */
import * as THREE from 'three';

export const degreeToMatrix = (degree) => {
  const radians = degree * (Math.PI / 180);
  const matrix = new THREE.Matrix4().makeRotationY(radians);
  return matrix;
};

export const degreeToMatrixZ = (degree) => {
  const radians = degree * (Math.PI / 180);
  const matrix = new THREE.Matrix4().makeRotationZ(radians);
  return matrix;
};

export const degreeToMatrixX = (degree) => {
  const radians = degree * (Math.PI / 180);
  const matrix = new THREE.Matrix4().makeRotationX(radians);
  return matrix;
};

export const calculateIntersection = (originA, vectorB, originC, vectorD) => {
  const a1 = originA.x;
  const a2 = originA.z;
  const b1 = vectorB.x;
  const b2 = vectorB.z;

  const c1 = originC.x;
  const c2 = originC.z;

  const d1 = vectorD.x;
  const d2 = vectorD.z;

  let x;
  let y;

  if (b1 < -0.00001 || b1 > 0.00001) {
    y = (a2 - c2 + ((c1 - a1) * b2) / b1) / (d2 - (d1 * b2) / b1);
    x = (c1 - a1 + d1 * y) / b1;
  } else {
    y = (b2 * a1 + b1 * c2 - b1 * a2 - c1 * b2) / (d1 * b2 - b1 * d2);
    x = (c2 + d2 * y - a2) / b2;
  }

  let intersection;

  if (x === 0) {
    intersection = originC.clone();
    intersection.add(vectorD.clone().multiplyScalar(y));
  } else {
    intersection = originA.clone();
    intersection.add(vectorB.clone().multiplyScalar(x));
  }

  return intersection;
};
